module.exports = __webpack_public_path__ + "img/lang-es-hover.86b37534.png";